<Checkbox class="checkbox" :id="`checkbox-${id}`" :modelValue="checked" @update:modelValue="changeValue"><slot></slot></Checkbox>